<template>
  <el-container class="is-vertical h-100">
    <el-container class="relative h-100">
      <filters-component v-on:submitFilters="searchHandler"></filters-component>
        <library-items :searchEnabled="true" :items="$store.state.libraryItems" v-on:delete-item="deleteTour"></library-items>
    </el-container>
  </el-container>
</template>

<script>
  import TabbedLinks from "../components/tabbed-links.vue"
  import LibraryItems from "../components/library-items.vue"
  import FiltersComponent from "../components/filters.vue"

  export default {
    name: 'Library',
    components: {
      TabbedLinks,
      LibraryItems,
      FiltersComponent
    },
    data () {
      return {
      }
    },
    mounted: function () {
      this.$store.state.libLoading = true;
      if (Object.keys(this.$route.query).length) return;
      // this.axios.get(this.$store.state.API_URL + 'demo?public=1&_start=0&_limit=16')
      //   .then((res) => {
      //     this.$store.commit("setState", {libraryItems: res.data});
      //     this.$store.state.libLoading = false;
      //   });
    },
    methods: {
      deleteTour(tour) {
        this.$store.state.libraryItems.splice(this.$store.state.libraryItems.indexOf(tour), 1)
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      searchHandler() {
        if (this.$store.state.libLoading) {
          return;
        }
        this.$store.state.libLoading = true;

        this.axios.post(this.$store.state.API_URL + 'demo/filter', {
          filters: this.$store.state.filters,
          search: this.$store.state.search,
          start: 0,
          limit: 64
        }).then((res) => {
          this.$store.commit("setState", {libraryItems: res.data});
          this.$store.state.libLoading = false;
          this.$router.replace({query: Object.assign({}, this.$store.getters.query)});
        });

      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/Library.vue